import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12.414",
  height: "12.414",
  viewBox: "0 0 12.414 12.414"
}
const _hoisted_2 = {
  id: "Group_7325",
  "data-name": "Group 7325",
  transform: "translate(-1313.317 -92.839)"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconClose',
  props: {
    classStroke: null,
    size: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("g", _hoisted_2, [
      _createElementVNode("line", {
        id: "L2",
        class: _normalizeClass([
          __props.classStroke,
          'svg-stroke',
        ]),
        y1: "11",
        x2: "11",
        transform: "translate(1314.024 93.546)",
        fill: "none",
        stroke: "#787c80",
        "stroke-width": "2"
      }, null, 2),
      _createElementVNode("line", {
        id: "L2-2",
        class: _normalizeClass([
          __props.classStroke,
          'svg-stroke',
        ]),
        "data-name": "L2",
        x1: "11",
        y1: "11",
        transform: "translate(1314.024 93.546)",
        fill: "none",
        stroke: "#787c80",
        "stroke-width": "2"
      }, null, 2)
    ])
  ]))
}
}

})